module.exports = __webpack_public_path__ + "img/s_0.cc68f8ec.png";